export default __webpack_public_path__ + "static/desktop_sek2_KV03-cd73a0c2e3881d95369d3cb2babd709b.mp4";